import React, {useContext} from 'react';
import './Orders.less';
import {ActiveOrderList} from "compositions/active-order-list/ActiveOrderList";
import {HistoryOrderList} from "compositions/history-order-list/HistoryOrderList";
import {PseudoPagePopup} from "dialog-layout/pseudo-page-popup/PseudoPagePopup";
import {Block} from "compositions/block/Block.tsx";
import {Card} from "elements/card/Card.tsx";
import {EmptyPlaceholder} from "elements/empty-placeholder/EmptyPlaceholder";
import {Button} from 'elements/button/Button';
import {TranslationsContext} from "contexts/translations-context";
import {getSafeTranslation} from "helpers/localization.helper.ts";
import {CardStyles} from "../../elements/card/Card";

export const ORDERS_POPUP = 'ORDERS_POPUP';

export const Orders = ({
												 currentActiveOrders = [],
												 currentHistoryOrders = [],
												 isUserLoggedIn,
												 onOrderClick,
												 onLogInClick,
												 onOverlayClick,
												 onEmailAllReceiptsClick,
												 onOrderAgainClick
											 }) => {

	const translations = useContext(TranslationsContext);

	return <PseudoPagePopup
		title={getSafeTranslation('OrdersPopup.title', translations)}
		onBackClick={onOverlayClick}
	>
		<div className="orders">
			{
				currentActiveOrders?.length === 0 && currentHistoryOrders?.length === 0 && (
					<div className="orders__placeholder">
						<Card style={CardStyles.NESTED}>
							{
								isUserLoggedIn
									? (<EmptyPlaceholder text={getSafeTranslation('OrdersPopup.emptyPlaceholder', translations)}/>)
									: (<div class="orders__login-placeholder">
											<EmptyPlaceholder text={getSafeTranslation('OrdersPopup.emptyNotLoggedInPlaceholder', translations)}/>
											<Button
												isAutoWidth
												onClick={onLogInClick}
											>
												{getSafeTranslation('OrdersPopup.loginButtonCaption', translations)}
											</Button>
										</div>)
							}
						</Card>
					</div>
				)
			}
			{
				currentActiveOrders?.length > 0 && (
					<div className="orders__active">
						<Block title={getSafeTranslation('OrdersPopup.activeBlockTitle', translations)} isNonScalable>
							<Card style={CardStyles.NESTED} isNoPaddings>
								<ActiveOrderList
									activeOrders={
										currentActiveOrders
											.sort((order1, order2) => order2.orderId - order1.orderId)
									}
									onOrderClick={onOrderClick}
									onOrderAgainClick={onOrderAgainClick}
								/>
							</Card>
						</Block>
					</div>
				)

			}

			{
				currentHistoryOrders?.length > 0 && (
					<div className="orders__history">
						<Block
							title={getSafeTranslation('OrdersPopup.previousBlockTitle', translations)}
							titleControl={<Button isLightText onClick={onEmailAllReceiptsClick}>
								{getSafeTranslation('OrdersPopup.sendPreviousToEmailButtonCaption', translations)}
							</Button>}
							isNonScalable
						>
							<Card style={CardStyles.NESTED} isNoPaddings>
								<HistoryOrderList
									historyOrders={
										currentHistoryOrders
											.sort((order1, order2) => order2.orderId - order1.orderId)
									}
									onOrderClick={onOrderClick}
									onOrderAgainClick={onOrderAgainClick}
								/>
							</Card>
						</Block>
					</div>
				)
			}

		</div>
	</PseudoPagePopup>
}
